import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './DeleteLeaveModal.module.css';

const DeleteLeaveModal = ({ open, onClose, onConfirm, request }) => {
  console.log('deleet req', request);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={styles.approveModal}>
      {/* Header */}
      <DialogTitle className={styles.modalHeader}>
        <Typography variant="h6" className={styles.modalTitle}>
          Delete Request
        </Typography>
        <IconButton onClick={onClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent className={styles.modalContent}>
        <Typography variant="body1" className={styles.confirmationText}>
          Are you sure you want to delete this request?
        </Typography>
        <Typography variant="body2" className={styles.warningText}>
          This action can’t be undone.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions className={styles.modalActions}>
        <Button onClick={onClose} variant="outlined" className={styles.cancelButton}>
          Cancel
        </Button>
        {/* api call left */}
        <Button onClick={() => onConfirm(request._id)} variant="contained" className={styles.deleteBtn}>
          Yes, Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteLeaveModal;
